module.exports = __webpack_public_path__ + "assets/img/icon_lock.6913dea5.svg";